module.exports = __webpack_public_path__ + "img/logoo-b.751c2b2f.svg";